import {debounceTime, distinctUntilChanged, switchMap} from "rxjs/operators";
import {TreeViewEntity} from "../../../models/tree-view-entity.model";
import {saveAs} from "file-saver";
import * as moment from "moment";
import {UserPersonInfo} from "../../../models/identity";
import {Subject, Subscription} from "rxjs";
import {Directive, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DrillDownComponent} from "../../../common/drilldown/drilldown.component";
import {ProcessReportModel} from "./process-report/process-report.mode";
import {ProcessDurationAppraiseeStage} from "../../../models/process-models";
import {ReportingService} from "../../../services/reporting.service";
import {BusinessUnitService} from "../../../services/business-unit.service";
import {ActivatedRoute} from "@angular/router";
import {UserService} from "../../../services/user.service";
import {ConfigService} from "../../../services/config.service";

@Directive()
export class ProcessReportBase implements OnInit, OnDestroy {
    businessUnits: Array<TreeViewEntity>;
    defaultbusinessUnitId: number;
    searchedEmployees: Array<UserPersonInfo>;
    isSpinnerEnable: boolean;
    @ViewChild("drilldownSelect") drilldownSelect: DrillDownComponent;
    model = new ProcessReportModel();
    Stages = {
        All: null,
        Active: [ProcessDurationAppraiseeStage.Active],
        Completed: [
            ProcessDurationAppraiseeStage.Completed,
            ProcessDurationAppraiseeStage.Cancelled,
        ],
    };
    employeeSearcheSubject = new Subject<string>();
    subscription: Subscription = new Subscription();
    
    constructor(
        protected  _reportingService: ReportingService,
        protected  _businessUnitService: BusinessUnitService,
        protected  _actRoute: ActivatedRoute,
        protected  _userService: UserService,
        protected  _configService: ConfigService
    ) {}
    
    ngOnInit() {
        this._businessUnitService.getTreeView().subscribe((businessUnits) => {
            this.businessUnits = businessUnits;
        });
        this.subscription.add(this._actRoute.parent.parent.paramMap.subscribe(
            (x) => {
                this.defaultbusinessUnitId = +x.get("businessUnitId");
            }
        ));

        this.subscription.add(this.employeeSearcheSubject
            .pipe(
                debounceTime(300),
                distinctUntilChanged(),
                switchMap((event) => this._userService.getBySearchPattern(event))
            )
            .subscribe((employees) => {
                this.searchedEmployees = employees;
            }));
    }

    onBusinessUnitSelected(businessUnit: TreeViewEntity) {
        this.model.BusinessUnit =
            businessUnit && businessUnit.id ? businessUnit : null;
    }

    searchEmployeeByName(search: string) {
        if (!this.checkIfPatternReady(search)) {
            return;
        }
        this.employeeSearcheSubject.next(search);
    }

    download(isReport: boolean = true) {
        if (this.model.invalid) {
            return;
        }
        this.isSpinnerEnable = true;
        this.subscription.add(
            (isReport 
                ? this._reportingService.getProcessExcelReport(this.model) 
                : this._reportingService.getProcessInfoReport(this.model)
            )
            .subscribe(
                (r) => {
                    saveAs(r, isReport ? `BU_Summary_report_${this.localeTime(new Date())}.xlsx` : `BU_Process_info_report_${this.localeTime(new Date())}.xlsx`);
                    this.isSpinnerEnable = false;
                },
                (x) => {
                    this.isSpinnerEnable = false;
                }
            ));
    }

    clearAll() {
        let startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        this.model.StartDate = startDate;
        this.model.EndDate = new Date();
        this.model.Employee = null;
        this.model.BusinessUnit = null;
        if (this.drilldownSelect) {
            this.drilldownSelect.onClearClicked();
        }
        this.model.Stages = this.Stages.All;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        
        if (this.employeeSearcheSubject) {
            this.employeeSearcheSubject.complete();
        }
    }

    private localeTime(source: Date) {
        const offset = moment().utcOffset();
        return moment
            .utc(source)
            .utcOffset(offset)
            .locale("en")
            .format("H:mm | D MMMM");
    }

    private checkIfPatternReady(pattern: string): boolean {
        return (
            pattern.length >= this._configService.configData.minimumSearchStringLength
        );
    }
}